import { render, staticRenderFns } from "./DownloadNoticeSection.vue?vue&type=template&id=09eda066&scoped=true"
import script from "./DownloadNoticeSection.vue?vue&type=script&lang=js"
export * from "./DownloadNoticeSection.vue?vue&type=script&lang=js"
import style0 from "./DownloadNoticeSection.vue?vue&type=style&index=0&id=09eda066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eda066",
  null
  
)

export default component.exports